var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148.376,
    height: 17.995,
    viewBox: "0 0 148.376 17.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#495fdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6991ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2",
    transform: "translate(0 0.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(0 -0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M23.42,17.692V.29H34.828V2.218h-9.24V7.832h9.051V9.76H25.588v5.994h9.24v1.928Z",
    transform: "translate(-0.024 0.008)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M45.259,13.566a7.362,7.362,0,0,0,5.484,2.487c3.107,0,4.1-1.678,4.1-3,0-2.088-2.118-2.657-4.415-3.287-2.787-.729-5.894-1.518-5.894-4.935C44.529,2,47.087,0,50.5,0a8.171,8.171,0,0,1,6.184,2.427L55.388,4a6.693,6.693,0,0,0-4.995-2.088c-2.088,0-3.576,1.129-3.576,2.767s1.968,2.318,4.176,2.9c2.847.749,6.084,1.638,6.084,5.294,0,2.527-1.728,5.115-6.423,5.115A8.631,8.631,0,0,1,44,15.214Z",
    transform: "translate(-0.046 0.008)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M67.08,17.692V.29h11.4V2.218h-9.24V7.832H78.3V9.76H69.238v5.994h9.24v1.928Z",
    transform: "translate(-0.07 0.008)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M98.76,17.692l-4.445-6.913H90.848v6.913H88.68V.29h6.993c3.187,0,5.454,2,5.454,5.245A4.815,4.815,0,0,1,96.612,10.6l4.705,7.093ZM95.413,2.218H90.848V8.871h4.565a3.257,3.257,0,0,0,3.476-3.337,3.237,3.237,0,0,0-3.476-3.317Z",
    transform: "translate(-0.092 0.008)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M3.848,17.692H1.68V.29H8.673c3.187,0,5.454,2,5.454,5.245A4.815,4.815,0,0,1,9.612,10.6l4.705,7.093H11.76",
    transform: "translate(-0.002 0.008)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M111.31,17.692V.29h7.752c3,0,4.875,1.828,4.875,4.435a4,4,0,0,1-3,4,4.335,4.335,0,0,1,3.337,4.266c0,2.8-1.848,4.7-4.995,4.7Zm2.168-9.86h5.215a2.707,2.707,0,0,0,3-2.8,2.737,2.737,0,0,0-3-2.817h-5.215Zm0,7.932H118.8c2,0,3.237-1.149,3.237-3a3,3,0,0,0-3.237-3h-5.324Z",
    transform: "translate(-0.116 0.008)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M139.543,17.692V10.34L132.68.29h2.527l5.4,8.092L145.986.29h2.527l-6.833,10.05v7.352Z",
    transform: "translate(-0.138 0.008)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 4.206,
    height: 3.317,
    rx: 0.16,
    transform: "translate(0 2.376)",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/LogoLight.ec30c91e.svg";
export { ForwardRef as ReactComponent };